/* ========== ZDV CORE (must be first) ========== */
(function (window, $) {
  'use strict';

  // Namespace
  window.zdv = window.zdv || {};
  var zdv = window.zdv;

  // Defaults (WP will localize ajaxurl; keep a fallback)
  if (!zdv.ajaxurl) zdv.ajaxurl = '/wp-admin/admin-ajax.php';
  zdv.nonces = zdv.nonces || {};
  zdv.i18n   = zdv.i18n   || {};

  // Reusable nonce fetcher (per page-view cache)
  // Usage: zdv.getNonce('rvp').then(nonce => { ... })
  if (!zdv.getNonce) {
    zdv.getNonce = function (key) {
      if (zdv.nonces[key]) {
        return $.Deferred().resolve(zdv.nonces[key]).promise();
      }
      return $.ajax({
        url: zdv.ajaxurl,
        type: 'POST',
        dataType: 'json',
        data: { action: 'zdv_get_nonce', key: key }
      }).then(function (resp) {
        if (resp && resp.success && resp.data && resp.data.nonce) {
          zdv.nonces[key] = resp.data.nonce;
          return resp.data.nonce;
        }
        return $.Deferred().reject(resp).promise();
      });
    };
  }
})(window, jQuery);
/* ========== /ZDV CORE ========== */



jQuery(document).ready(function($){
	"use strict";
	
	
	//////// Fix Ajax On Super Speedy Filters
	$(document).on('click', '.wc-layered-nav-term, .show-existing-filters a', function (e) {
		e.preventDefault();
	});
	
	
/**
 * Slick Slider for WooCommerce Products in zdv-post-products-wrapper
 * Requires: Slick Slider library (CSS and JS)
 * Add this to your custom JavaScript file
 */

(function($) {
    'use strict';
    
    // Wait for DOM to be ready
    $(document).ready(function() {
        
        // Initialize Slick on products wrapper
        var $productsSlider = $('.zdv-post-products-wrapper ul.products');
        
        // Check if element exists and Slick is available
        if ($productsSlider.length && typeof $.fn.slick !== 'undefined') {
            
            $productsSlider.slick({
                // Desktop: 4 products
                slidesToShow: 3,
                slidesToScroll: 1,
                
                // Center mode
                centerMode: false,
                ///centerPadding: '60px',
                
                // Enable infinite loop
                infinite: true,
                
                // Auto-scroll settings (optional - remove if not needed)
                autoplay: false,
                autoplaySpeed: 3000,
                
                // Navigation arrows with Font Awesome icons
                arrows: true,
                prevArrow: '<span class="zdv-left-slide-arrow zdv-slide-arrow"><i class="fa fa-chevron-circle-left"></i></span>',
                nextArrow: '<span class="zdv-right-slide-arrow zdv-slide-arrow"><i class="fa fa-chevron-circle-right"></i></span>',
                
                // No dots navigation
                dots: false,
                
                // Smooth transitions
                speed: 300,
                cssEase: 'ease-in-out',
                
                // Accessibility
                accessibility: true,
                
                // Touch settings - fix for passive event listener warning
                touchThreshold: 10,
                swipe: true,
                swipeToSlide: true,
				
				adaptiveHeight: true,
                
                // Responsive breakpoints (Bootstrap 5 breakpoints)
                responsive: [
                    {
                        // Tablet: 768px to 991px (Bootstrap md breakpoint)
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            centerMode: true,
                            centerPadding: '0px',
                            arrows: true,
                            infinite: true
                        }
                    },
                    {
                        // Mobile: below 768px (Bootstrap sm breakpoint)
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            centerMode: true,
                            centerPadding: '0px',
                            arrows: true,
                            infinite: true
                        }
                    }
                ]
            });
            
            // Fix for passive event listener warning on touch devices
            // Override Slick's default touch event handlers
            $productsSlider.on('touchstart', function(e) {
                // Allow default behavior
            });
            
            $productsSlider.on('touchmove', function(e) {
                // Allow default behavior
            });
            
        }
        
    });
    
})(jQuery);

	
	
	
//Quantity PLus/Minus	
(function ($) {
  function getStep($input) {
    var stepAttr = ($input.attr('step') || '').toLowerCase();
    if (!stepAttr || stepAttr === 'any') return 1;
    var s = parseFloat(stepAttr);
    return isNaN(s) ? 1 : s;
  }

  function getPrecision(num) {
    var s = String(num);
    var idx = s.indexOf('.');
    return idx === -1 ? 0 : (s.length - idx - 1);
  }

  $(document).on('click', '.zdv-qty .qty-btn', function () {
    var $btn = $(this);
    var $wrap = $btn.closest('.zdv-qty');
    var $input = $wrap.find('input.qty');

    if ($input.is('[readonly]') || $input.is(':disabled')) return;

    var step = getStep($input);
    var min  = parseFloat($input.attr('min'));
    if (isNaN(min)) min = 0;

    var maxAttr = $input.attr('max');
    var max  = (maxAttr !== undefined && maxAttr !== '') ? parseFloat(maxAttr) : Infinity;

    var curr = parseFloat(($input.val() || '').toString().replace(',', '.'));
    if (isNaN(curr)) curr = min || 0;

    var dir = $btn.hasClass('qty-plus') ? 1 : -1;
    var next = curr + dir * step;

    // Clamp
    if (next < min) next = min;
    if (next > max) next = max;

    // Align to step precision & avoid 0.30000000004
    var precision = Math.max(getPrecision(step), 0);
    next = Number(next.toFixed(precision));

    $input.val(next)
      .trigger('input')   // for scripts listening to live input
      .trigger('change'); // Woo updates totals/cart on change
  });
})(jQuery);
//Select onfocus
jQuery(function ($) {
  function getStep($i){ const s=($i.attr('step')||'').toLowerCase(); if(!s||s==='any') return 1; const n=parseFloat(s); return isNaN(n)?1:n; }
  function getPrec(n){ const s=String(n),i=s.indexOf('.'); return i===-1?0:(s.length-i-1); }

  // Select all on focus
  $(document).on('focus', 'input.qty:not([readonly]):not([disabled])', function () {
    var $i = $(this);

    // If it's a number input, temporarily make it text so we can select
    if ($i.attr('type') === 'number') {
      $i.attr('data-restore-type', '1')
        .attr('type', 'text')               // enables selection
        .attr('inputmode', 'decimal');      // keep numeric keypad on mobile
    }

    // Select the whole value
    setTimeout(function () {
      var el = $i.get(0);
      try { el.setSelectionRange(0, (el.value || '').length); }
      catch (e) { el.select && el.select(); }
    }, 0);
  });

  // Keep selection on mouseup (Chrome quirk)
  $(document).on('mouseup', 'input.qty', function (e) { e.preventDefault(); });

  // On blur, sanitize value, clamp to min/max, snap to step, and restore type
  $(document).on('blur', 'input.qty', function () {
    var $i = $(this);

    // numeric cleanup
    var val = ($i.val() || '').toString().replace(',', '.');
    var num = parseFloat(val);
    var min = parseFloat($i.attr('min')); if (isNaN(min)) min = 0;
    var maxAttr = $i.attr('max'); var max = (maxAttr !== undefined && maxAttr !== '') ? parseFloat(maxAttr) : Infinity;
    var step = getStep($i);
    if (isNaN(num)) num = min;
    num = Math.max(min, Math.min(max, num));
    num = Number(num.toFixed(Math.max(getPrec(step), 0)));
    $i.val(num).trigger('change'); // let Woo update totals

    // restore original number type if we switched it
    if ($i.attr('data-restore-type')) {
      $i.removeAttr('data-restore-type').attr('type', 'number');
    }
  });
});

	
(function ($) {
  $(function () {

    function initSwitches(ctx) {
      $('.bm-view-switch', ctx || document).each(function (i) {
        var $switch = $(this);

        // Find the FIRST products UL that follows this switch
        var $wrap = $switch.nextAll('ul.products').first();
        if (!$wrap.length) {
          // Fallback: look within the same parent (handles some templates)
          $wrap = $switch.parent().find('ul.products').first();
        }
        if (!$wrap.length) return; // nothing to control

        // Stable per-loop key (path + loop id). Create an id if missing.
        var lid = $wrap.attr('id');
        if (!lid) {
          lid = 'wc-loop-' + ($('ul.products').index($wrap) + 1);
          $wrap.attr('id', lid);
        }
        var KEY = 'bmProdView:' + location.pathname + ':' + lid;

        var $btns = $switch.find('[data-view]');

        function apply(view) {
          // Toggle classes ONLY on this loop
          if (view === 'list') {
            $wrap.addClass('bm-list').removeClass('bm-grid');
          } else {
            $wrap.addClass('bm-grid').removeClass('bm-list');
          }

          // Button UI in THIS switch
          $btns
            .removeClass('active')
            .attr('aria-pressed', 'false')
            .filter('[data-view="' + view + '"]')
            .addClass('active')
            .attr('aria-pressed', 'true');

          try { localStorage.setItem(KEY, view); } catch (e) {}
        }

        // Initial state (per loop)
        var saved = null;
        try { saved = localStorage.getItem(KEY); } catch (e) {}
        apply((saved === 'list' || saved === 'grid') ? saved : 'grid');

        // Clicks (scoped to this switch)
        $btns.off('click.bmview').on('click.bmview', function (e) {
          e.preventDefault();
          apply($(this).data('view'));
        });
      });
    }

    // Run now
    initSwitches();

    // If your page injects loops via AJAX, call initSwitches(newContext)
    // or uncomment a simple MutationObserver:
    /*
    new MutationObserver(function(muts){
      for (const m of muts) {
        if ($(m.addedNodes).find('ul.products, .bm-view-switch').length) {
          initSwitches(m.target);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
    */
  });
})(jQuery);

// RVP
(function($){
  'use strict';

  // Use global helper if present; otherwise local fallback
  function getNonce(key){
    if (window.zdv && typeof zdv.getNonce === 'function') {
      return zdv.getNonce(key);
    }
    // local fallback (kept tiny)
    window.zdv = window.zdv || {};
    zdv.nonces = zdv.nonces || {};
    if (zdv.nonces[key]) {
      return $.Deferred().resolve(zdv.nonces[key]).promise();
    }
    return $.ajax({
      url: (zdv && zdv.ajaxurl) ? zdv.ajaxurl : '/wp-admin/admin-ajax.php',
      type: 'POST',
      dataType: 'json',
      data: { action: 'zdv_get_nonce', key: key }
    }).then(function(resp){
      if (resp && resp.success && resp.data && resp.data.nonce) {
        zdv.nonces[key] = resp.data.nonce;
        return resp.data.nonce;
      }
      return $.Deferred().reject(resp).promise();
    });
  }

  function initSlider($wrap){
    var $slider = $wrap.find('.recently-viewed-slider');
    if (!$slider.length) return;

    $slider.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      prevArrow: '<span class="zdv-left-slide-arrow zdv-slide-arrow"><i class="fa fa-chevron-circle-left"></i></span>',
      nextArrow: '<span class="zdv-right-slide-arrow zdv-slide-arrow"><i class="fa fa-chevron-circle-right"></i></span>',
      dots: false,
      centerMode: false,
      focusOnSelect: true,
      adaptiveHeight: true,
      lazyLoad: 'ondemand',
      waitForAnimate: false,
      responsive: [
        { breakpoint: 1200, settings: { slidesToShow: 3 } },
        { breakpoint: 992,  settings: { slidesToShow: 2 } },
        { breakpoint: 576,  settings: { slidesToShow: 2 } }
      ]
    });
  }

  function renderOrRemove($wrap, res){
    if (res && res.success && res.data && res.data.html) {
      if (res.data.html.trim().length) {
        $wrap.html(res.data.html);
        initSlider($wrap);
        return;
      }
    }
    $wrap.remove();
  }

  function loadRVP($wrap){
    var currentId = $wrap.data('product-id');

    function doRequest(){
      return $.when( getNonce('rvp') ).then(function(nonce){
        return $.post(zdv.ajaxurl, {
          action: 'zdv_recently_viewed',
          _ajax_nonce: nonce,
          exclude: currentId
        }, null, 'json');
      });
    }

    // First try
    doRequest().done(function(res){
      renderOrRemove($wrap, res);
    }).fail(function(jqXHR){
      // Retry once on 403 (expired nonce), then give up
      if (jqXHR && jqXHR.status === 403) {
        if (window.zdv && zdv.nonces) delete zdv.nonces.rvp; // force refresh
        doRequest().done(function(res2){
          renderOrRemove($wrap, res2);
        }).fail(function(){ $wrap.remove(); });
      } else {
        $wrap.remove();
      }
    });
  }

  $(function(){
    var $wrap = $('#rvp');
    if (!$wrap.length) return;

    // Lazy fetch when visible (or after idle)
    if ('IntersectionObserver' in window) {
      var fired = false;
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (!fired && e.isIntersecting) {
            fired = true; io.disconnect(); loadRVP($wrap);
          }
        });
      }, { rootMargin: '200px' });
      io.observe($wrap[0]);

      if ('requestIdleCallback' in window) {
        requestIdleCallback(function(){
          if (!fired) { fired = true; io.disconnect(); loadRVP($wrap); }
        }, { timeout: 4000 });
      }
    } else {
      setTimeout(function(){ loadRVP($wrap); }, 1000);
    }
  });
})(jQuery);



// ==============================
// Cat Nav (nonce-safe with retry)
// ==============================
jQuery(function ($) {
  'use strict';
  const $doc = $(document);

  // Use global helper if present; else tiny local fallback
  function getNonce(key) {
    if (window.zdv && typeof window.zdv.getNonce === 'function') {
      return window.zdv.getNonce(key);
    }
    // local fallback
    window.zdv = window.zdv || {};
    const Z = window.zdv;
    Z.nonces = Z.nonces || {};

    if (Z.nonces[key]) {
      return $.Deferred().resolve(Z.nonces[key]).promise();
    }
    return $.ajax({
      url: (Z && Z.ajaxurl) ? Z.ajaxurl : '/wp-admin/admin-ajax.php',
      type: 'POST',
      dataType: 'json',
      data: { action: 'zdv_get_nonce', key: key }
    }).then(function (resp) {
      if (resp && resp.success && resp.data && resp.data.nonce) {
        Z.nonces[key] = resp.data.nonce;
        return resp.data.nonce;
      }
      return $.Deferred().reject(resp).promise();
    });
  }

  function toggleIcon($btn, expanded) {
    const $icon = $btn.find('.zdv-icon');
    if ($icon.length) {
      $icon.html(expanded ? '<i class="fa fa-minus"></i>' : '<i class="fa fa-plus"></i>');
    }
  }

  function setLoading($btn, isLoading) {
    const $icon = $btn.find('.zdv-icon');
    const $spn  = $btn.find('.zdv-loading');
    $btn.prop('disabled', !!isLoading);
    $icon.toggleClass('d-none', !!isLoading);
    $spn.toggleClass('d-none', !isLoading);
  }

  $doc.on('click', '.zdv-term-toggle', function (e) {
    e.preventDefault();

    const $btn     = $(this);
    const controls = $btn.attr('aria-controls');
    const $target  = $('#' + controls);
    if (!$target.length) return;

    // Already loaded → just toggle
    if ($target.data('loaded') === 1) {
      $target.slideToggle(150, function () {
        const isNowOpen = $target.is(':visible');
        $btn.attr('aria-expanded', isNowOpen ? 'true' : 'false');
        toggleIcon($btn, isNowOpen);
      });
      return;
    }

    // First time: fetch via AJAX (with fresh nonce)
    const parentId = $btn.closest('[data-term-id]').data('term-id');
    setLoading($btn, true);

    function doRequest() {
      return $.when(getNonce('cats_expand')).then(function (nonce) {
        return $.ajax({
          url: (window.zdv && zdv.ajaxurl) ? zdv.ajaxurl : '/wp-admin/admin-ajax.php',
          type: 'POST',
          dataType: 'json',
          data: {
            action: 'zdv_fetch_child_cats',
            nonce:  nonce,
            parent: parentId
          }
        });
      });
    }

    doRequest().done(function (resp) {
      const html = (resp && resp.data && resp.data.html)
        ? String(resp.data.html)
        : '<div class="p-2 small opacity-75">No subcategories</div>';

      $target.html(html).data('loaded', 1).slideDown(150);
      $btn.attr('aria-expanded', 'true');
      toggleIcon($btn, true);

    }).fail(function (jqXHR) {
      // Retry once on 403 (expired nonce)
      if (jqXHR && jqXHR.status === 403 && window.zdv && zdv.nonces) {
        delete zdv.nonces.cats_expand;
        doRequest().done(function (resp2) {
          const html2 = (resp2 && resp2.data && resp2.data.html)
            ? String(resp2.data.html)
            : '<div class="p-2 small opacity-75">No subcategories</div>';

          $target.html(html2).data('loaded', 1).slideDown(150);
          $btn.attr('aria-expanded', 'true');
          toggleIcon($btn, true);
        }).fail(function () {
          alert('Error loading subcategories.');
        }).always(function () {
          setLoading($btn, false);
        });
        return; // prevent falling through
      }
      alert('Error loading subcategories.');
    }).always(function () {
      setLoading($btn, false);
    });
  });
});



	
	
	jQuery(function ($) {
	  // Delegate so it works for dynamically-added content too
	  $(document).on('click', '.zdv-read-more', function (e) {
		e.preventDefault();

		var $btn  = $(this);
		var $wrap = $btn.closest('.show-read-more');
		var $long = $wrap.find('.zdv-archive-long-text');

		// Prepare for animation: ensure it's hidden via inline style,
		// then remove the .hidden class and slide down.
		$long.stop(true, true).hide().removeClass('hidden').slideDown(200);

		// Remove the "Read more" link
		$btn.remove();
	  });
	});
	// Alert for variations
	jQuery(function ($) {
	  // Use Woo's own text if available; otherwise a fallback
	  var alertMsg =
		(window.wc_add_to_cart_variation_params &&
		  (window.wc_add_to_cart_variation_params.i18n_select_options_text ||
		   window.wc_add_to_cart_variation_params.i18n_make_a_selection_text)) ||
		'Please select a variation first.';

	  // Fire on click of a disabled add-to-cart button OR when its wrapper is in disabled state
	  $(document).on(
		'click',
		'.woocommerce-variation-add-to-cart-disabled',
		function (e) {
		  e.preventDefault();
		  e.stopImmediatePropagation();
		  alert(alertMsg);
		  return false;
		}
	  );
	});

	//Start Here!
	//Show More on Product Page
	jQuery(function ($) {
	  $(document).on('click', '.zdv-show-more', function (e) {
		e.preventDefault();

		var $btn = $(this);
		var targetSel = $btn.attr('data-target');
		if (!targetSel) return;

		var $list = $(targetSel);
		if (!$list.length) return;

		var expanded = $list.attr('data-expanded') === '1';
		var $hiddenItems = $list.find('li[data-hidden="1"]');

		// Show or hide hidden items
		$hiddenItems.toggleClass('d-none', expanded);

		// Flip state
		$list.attr('data-expanded', expanded ? '0' : '1');

		// Update button text
		var showText = $btn.attr('data-show-text') || 'Show more';
		var hideText = $btn.attr('data-hide-text') || 'Show less';
		$btn.text(expanded ? showText : hideText);
	  });
	});

	//Fancy Scroll
	// Fancy Scroll (safer: defer the .offset() read one frame)
	$(document).on('click', '.zdv-scroll-to', function (e) {
	  e.preventDefault();

	  const targetSel = $(this).attr('data-scroll_to');
	  if (!targetSel) return;

	  requestAnimationFrame(() => {
		const $t = $(targetSel);
		if (!$t.length) return;
		const top = $t.offset().top - 150;
		$('html, body').stop(true).animate({ scrollTop: Math.max(0, top) }, 300);
	  });
	});

/*	$(".zdv-scroll-to").click(function(e) {
		e.preventDefault();
		var scrl_to = $(this).attr('data-scroll_to');
		if(scrl_to != ''){
			$([document.documentElement, document.body]).animate({
				scrollTop: $(scrl_to).offset().top-150
			}, 300);
		}
	});*/
	//Review Form Modal Opening from URL
	
	if (window.location.href.indexOf('#ReviewFormModal') != -1) {
		$('#ReviewFormModal').modal('show');
	}
	if (window.location.href.indexOf('#zdv-login-modal') != -1) {
		$('#zdv-login-modal').modal('show');
	}
	if (window.location.href.indexOf('#zdv-user-register') != -1) {
		$('#zdv-user-register').modal('show');
	}
	//Review Opening and Scroll
	// Review Opening and Scroll (read before expanding; still defer the read)
	$('body').on('click', '.zdv-scroll-to-rating', function (e) {
	  e.preventDefault();

	  const targetSel = '#headingHTCR';

	  requestAnimationFrame(() => {
		const $t = $(targetSel);
		if (!$t.length) return;

		const top = $t.offset().top - 100;
		$('html, body').stop(true).animate({ scrollTop: Math.max(0, top) }, 800);
		// expand AFTER we’ve initiated the scroll
		$("#headingHTCR span")[0]?.click();
	  });
	});

/*	$("body").on("click", ".zdv-scroll-to-rating", function (e) {
		e.preventDefault();
		var scrl_to = '#headingHTCR';
		if(scrl_to != ''){
			$([document.documentElement, document.body]).animate({
				scrollTop: $(scrl_to).offset().top-100
			}, 800);
			$("#headingHTCR span")[0].click();
		}
    });*/
	//Share Buttons
	jQuery(function($){
	  $("body").on("click", ".zdv-share-btn", function (e) {
		e.preventDefault();
		var redirect = $(this).attr("data-redirect");
		if (!redirect) return;
		window.open(redirect, "share-dialog", "width=626,height=436");
	  });
	});
	//Ajax Refresh Counts
	jQuery(function($){
	  const $box = $('.zdv-social-share-article[data-post-id]');
	  if (!$box.length) return;

	  const postId = $box.data('post-id');
	  fetch('/wp-json/zdv/v1/share-counts?post=' + postId, { credentials: 'same-origin' })
		.then(r => r.ok ? r.json() : null)
		.then(data => {
		  if (!data) return;
		  // Update badges next to buttons
		  const clicks = data.clicks || {};
		  const fbTot  = (data.fb && data.fb.total) ? data.fb.total : 0;

		  // Facebook
		  const $fb = $box.find('.zdv-fb-share .zdv-count');
		  if ($fb.length) {
			const mine = parseInt(clicks.facebook || 0, 10);
			$fb.text( fbTot ? `${mine} (FB ${fbTot})` : `${mine}` );
		  }
		  // X
		  const $x = $box.find('.zdv-x-share .zdv-count');
		  if ($x.length) $x.text( parseInt(clicks.x || 0, 10) );
		  // WhatsApp
		  const $wa = $box.find('.zdv-whatsapp-share .zdv-count');
		  if ($wa.length) $wa.text( parseInt(clicks.whatsapp || 0, 10) );
		  // Telegram
		  const $tg = $box.find('.zdv-telegram-share .zdv-count');
		  if ($tg.length) $tg.text( parseInt(clicks.telegram || 0, 10) );
		})
		.catch(()=>{ /* fail silently */ });
	});

	
	//!!! MObile Right Nav
	// Generic: duplicate any block into the offcanvas, with unique IDs preserved.
	(function ($) {
	  // Attributes that may reference element IDs
	  const REF_ATTRS = [
		'for', 'aria-controls', 'aria-labelledby', 'aria-describedby',
		'data-bs-target', 'data-bs-parent', 'data-bs-container', 'data-bs-toggle',
		'href'
	  ];

	  // Build an ID map for all elements under $root and rewrite references
	  function remapIds($root, suffix) {
		const idMap = {};

		// 1) Collect all ids in this subtree
		$root.find('[id]').each(function () {
		  const oldId = this.id;
		  const newId = `${oldId}${suffix}`;
		  idMap[oldId] = newId;
		  this.id = newId;
		});

		// 2) Fix attributes that reference those ids
		$root.find('*').each(function () {
		  const $el = $(this);

		  REF_ATTRS.forEach(attr => {
			if (!$el.is(`[${attr}]`)) return;
			let val = $el.attr(attr);
			if (!val) return;

			// Case A: value is "#oldId" or exactly "oldId"
			if (val.charAt(0) === '#') {
			  const raw = val.slice(1);
			  if (idMap[raw]) $el.attr(attr, `#${idMap[raw]}`);
			  return;
			}
			if (idMap[val]) {
			  $el.attr(attr, idMap[val]);
			  return;
			}

			// Case B: some components put multiple selectors/ids (rare). Try replace tokens.
			Object.keys(idMap).forEach(oldId => {
			  // Replace occurrences of #oldId
			  val = val.replace(new RegExp(`#${oldId}(?![\\w-])`, 'g'), `#${idMap[oldId]}`);
			});
			$el.attr(attr, val);
		  });
		});

		return idMap;
	  }

	  // Main duplicator
	  function duplicateToOffcanvas(opts) {
		const settings = $.extend({
		  source: '.zdv-article-contents',
		  target: '.zdv-contents-offcanvas .offcanvas-body',
		  // when true, copy jQuery data & bound handlers on descendants
		  copyEvents: true,
		  // a stable suffix; if omitted, generate per run
		  suffix: null
		}, opts || {});

		const $src = $(settings.source).first();
		const $dst = $(settings.target).first();
		if (!$src.length || !$dst.length) return;

		// Avoid re-duplication
		if ($dst.children('.zdv-dup-root').length) return;

		// 1) Clone (deep), including events/data if requested
		const $clone = $src.clone(!!settings.copyEvents, !!settings.copyEvents);
		$clone.addClass('zdv-dup-root'); // marker so we can remove/rebuild if needed

		// 2) Give the clone a unique ID suffix and rewrite all internal refs
		const suffix = settings.suffix || `-dup-${Date.now()}-${Math.floor(Math.random()*1e5)}`;
		remapIds($clone, suffix);

		// 3) Append to offcanvas body
		$dst.append($clone);
	  }

	  // Expose globally
	  window.ZDV_duplicateToOffcanvas = duplicateToOffcanvas;

	})(jQuery);

	// Run once on DOM ready
	jQuery(function () {
	  ZDV_duplicateToOffcanvas({
		source:  '.zdv-article-contents',
		target:  '.zdv-contents-offcanvas .offcanvas-body',
		copyEvents: true
	  });
	});
	//End
	
	// Delegated handler (covers dynamically injected links)
	$(document).on('click', '.zdv-contents-offcanvas li:not(.zdv-cats-list) a', function (e) {
	  const targetSel = $(this).attr('data-scroll_to'); // e.g. "#section-1"
	  if (!targetSel) return; // no data-scroll_to -> behave like a normal link

	  const $target = $(targetSel);
	  if (!$target.length) return; // invalid selector -> let it act as a normal link

	  e.preventDefault();

	  // Optional: compensate fixed header height
	  //const headerH = $('.site-header:visible').outerHeight() || 0; alert('height:'+headerH);
	  const headerH = 155;

	  $('html, body').stop(true).animate(
		{ scrollTop: $target.offset().top - (headerH + 10) },
		300
	  );

	  // Close the offcanvas
	  const offcanvasEl = document.querySelector('.zdv-contents-offcanvas');
	  if (offcanvasEl && window.bootstrap?.Offcanvas) {
		window.bootstrap.Offcanvas.getOrCreateInstance(offcanvasEl).hide();
	  } else {
		$('.zdv-contents-offcanvas .btn-close').trigger('click');
	  }
	});

	(function(){
	  let ticking = false;
	  const btn = document.querySelector('.zdv-fixed-contents-btn');
	  if (!btn) return;

	  function frame() {
		ticking = false;
		const scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
		btn.classList.toggle('show', scrollY > 300);
	  }
	  window.addEventListener('scroll', () => {
		if (!ticking) { ticking = true; requestAnimationFrame(frame); }
	  }, { passive: true });
	})();

/*	var btn = $('.zdv-fixed-contents-btn');

	$(window).scroll(function() {
	  if ($(window).scrollTop() > 300) {
		btn.addClass('show');
	  } else {
		btn.removeClass('show');
	  }
	});*/
	//Cart Ofcanvas fix in desktop
	jQuery(function ($) {
	  var lastScrollY = 0;
	  var oc = document.getElementById('offcanvasCart');

	  if (!oc) return;

	  oc.addEventListener('show.bs.offcanvas', function () {
		lastScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
	  });

	  oc.addEventListener('hidden.bs.offcanvas', function () {
		// blur the trigger to stop the browser from scrolling it into view
		if (document.activeElement && document.activeElement.matches('[data-bs-toggle="offcanvas"]')) {
		  document.activeElement.blur();
		}
		// restore the scroll position after Bootstrap finishes its cleanup
		setTimeout(function () {
		  window.scrollTo({ top: lastScrollY, left: 0, behavior: 'auto' });
		}, 0);
	  });
	});
	//Automatewoo Optin Form
	//
	jQuery(function($){
	  var $form = $('#aw-optin-form');
	  if (!$form.length) return;

	  var $btn = $('#aw-submit'),
		  $spin = $('#aw-spin'),
		  $ok = $('#aw-optin-ok'),
		  $err = $('#aw-optin-err'),
		  ajaxUrl = $form.data('ajax-url'),
		  nonce   = $form.data('nonce');

	  $form.on('submit', function(e){
		e.preventDefault();

		// HTML5 validity check
		if (this.checkValidity() === false) {
		  e.stopPropagation();
		  $form.addClass('was-validated');
		  return;
		}

		$btn.prop('disabled', true);
		$spin.removeClass('d-none');
		$ok.addClass('d-none');
		$err.addClass('d-none');

		var payload = {
		  action: 'aw_optin_subscribe',
		  nonce: nonce,
		  name:  $.trim($('#aw-name').val() || ''),
		  email: $.trim($('#aw-email').val() || ''),
		  //debug: 1,
          t: $form.find('input[name="t"]').val(),
          website: $form.find('#aw-website').val() || ''
		}

		$.ajax({
		  url: zdv.ajaxurl,
		  method: 'POST',
		  dataType: 'json',
		  data: payload
		})
		.done(function(res){
		  if (res && res.success) {
			$ok.removeClass('d-none');
			$form[0].reset();
			$form.removeClass('was-validated');
		  } else {
			var msg = (res && res.data) ? res.data : 'Could not subscribe right now.';
			$err.text(msg).removeClass('d-none');
		  }
		})
		.fail(function(){
		  $err.text('Network error. Please try again.').removeClass('d-none');
		})
		.always(function(){
		  $btn.prop('disabled', false);
		  $spin.addClass('d-none');
		});
	  });
	});
	//Some TimeOut
	jQuery(function($){
	  var $btn = $('#aw-submit');
	  $btn.prop('disabled', true);
	  setTimeout(function(){ $btn.prop('disabled', false); }, 2500); // 2.5s
	});

	////Focus Search in Modal
	  $('#searchModal').on('shown.bs.modal', function () {
		const $input = $('#modal-search-input');
		if ($input.length) {
		  // slight delay helps on iOS/Safari
		  setTimeout(function () {
			$input.trigger('focus');
			// move caret to end (nice for repeated searches)
			const el = $input.get(0);
			el.setSelectionRange(el.value.length, el.value.length);
		  }, 10);
		}
	  });

	////Sticky
	//Scroll Site
	$(function() {

		//caches a jQuery object containing the header element
		var site = $(".zdv-top-navbar");
		var site2 = $(".zdv-main-navbar");
		$(window).scroll(function() {
			
	   if($(window).scrollTop() + $(window).height() > $(document).height() - 100) {
		   $("body").addClass("near-bottom");
	   }
		else{
			$("body").removeClass("near-bottom");
		}
			
			var scroll = $(window).scrollTop();
	
			if (scroll >= 70) {
				if(!$("body").hasClass("near-bottom")){
					site.removeClass('no-scroll-site').addClass("scroll-site");
					site2.removeClass('no-scroll-site').addClass("scroll-site");
					$("body").removeClass('no-scroll-body').addClass("scroll-body");
				}
			} else {
				site.removeClass("scroll-site").addClass('no-scroll-site');
				site2.removeClass("scroll-site").addClass('no-scroll-site'); 
				$("body").removeClass("scroll-body").addClass('no-scroll-body');
			}
		});
	});
	//Mini Cart
	
	//Force Cart Fragments
	jQuery.ajax({
	  url: wc_cart_fragments_params.wc_ajax_url.replace('%%endpoint%%', 'get_refreshed_fragments'),
	  type: 'POST',
	  success: function(data) {
		if (data && data.fragments) {
		  jQuery.each(data.fragments, function(key, value) {
			jQuery(key).replaceWith(value);
		  });
		}
	  }
	});

	
	//Cart Update
	//Cart Quantities
	$('.woocommerce').on('focus', 'input.qty', function(){
		$(this).prev().prev('.btn-cart-update').fadeIn();
	});
	

	$(document).on('change', '.woocommerce-mini-cart .qty-m', function () {
        var $input = $(this);
        var cart_item_key = $input.attr('name').match(/\[([^\]]*)\]/)[1]; // Extract cart item key
		
        var new_qty = parseInt($input.val());
		

        if (new_qty < 1) {
            new_qty = 1; // Prevent negative or zero quantities
            $input.val(new_qty);
        }

        // Indicate loading state
        $('.widget_shopping_cart_content').addClass('zdv-updating-cart');
        $.ajax({
            type: 'POST',
			dataType: 'html',
			//context: this,
			cache: false,
            url: zdv.ajaxurl,
            data: {
                'action': 'zdv_update_mini_cart_quantity',
                cart_item_key: cart_item_key,
                new_qty: new_qty,
            },
            success: function(response) {
                // Trigger WooCommerce fragment refresh to update mini-cart
                $(document.body).trigger('wc_fragment_refresh');
                $('.widget_shopping_cart_content').removeClass('zdv-updating-cart');
				//$('.zdv-mini-cart').html(response);
				//console.log(response);
            },
            error: function(response) {
                $('.widget_shopping_cart_content').removeClass('zdv-updating-cart');
                //alert('Error updating cart. Please try again.');
				//console.log(response);
            }
        });
    });
	
	
	
	
	
/*	$(document).ready(function(){
		$.ajax({
			type: 'POST',
            url: zdv.ajaxurl,
			data: { 
				'action': 'zdv_cart_total',
			},
			context: this,
			dataType: 'html',
			cache: true,
			success: function(data){
				$('.zdv-mini-cart').html(data);
			}
	    });
	});*/
	
	
	/////
  /// Ajax Add to Cart


  jQuery(function ($) {
    /* global wc_add_to_cart_params */
    if (typeof wc_add_to_cart_params === 'undefined') {
      return false;
    }

    $(document).on('submit', 'form.cart', function (e) {
      var form = $(this),
          button = form.find('.single_add_to_cart_button');
      var formFields = form.find('input:not([name="product_id"]), select, button, textarea'); //Custom for tracking

      /*				var p_name = $('.single_add_to_cart_button').attr("data-product_name");
      				var p_sku = $('.single_add_to_cart_button').attr("data-product_sku");
      				var p_cat = $('.single_add_to_cart_button').attr("data-product_category");
      				var p_price = $('.single_add_to_cart_button').attr("data-product_price");
      				var p_quantity = $('#mainVarQty').val();*/
      // create the form data array

      var formData = [];
      formFields.each(function (i, field) {
        // store them so you don't override the actual field's data
        var fieldName = field.name,
            fieldValue = field.value;

        if (fieldName && fieldValue) {
          // set the correct product/variation id for single or variable products
          if (fieldName == 'add-to-cart') {
            fieldName = 'product_id';
            fieldValue = form.find('input[name=variation_id]').val() || fieldValue;
          } // if the fiels is a checkbox/radio and is not checked, skip it


          if ((field.type == 'checkbox' || field.type == 'radio') && field.checked == false) {
            return;
          } // add the data to the array


          formData.push({
            name: fieldName,
            value: fieldValue
          });
        }
      });

      if (!formData.length) {
        return;
      }

      e.preventDefault();
      form.block({
        message: null,
        overlayCSS: {
          background: "transparent",
          opacity: 0.6
        }
      });
	  
      $(document.body).trigger('adding_to_cart', [button, formData]);
      
		$.ajax({
        type: 'POST',
		cache: false,
        url: woocommerce_params.wc_ajax_url.toString().replace('%%endpoint%%', 'add_to_cart'),
        data: formData,
        success: function (response) {
          if (!response) {
            return;
          }

          if (response.error) {
            //window.location = response.product_url;
            return;
          } else {
			  
            $('.zdv-mini-cart').html(response['fragments']['div.widget_shopping_cart_content']);
			//Show the minicart
			$('.cart-menu-item a')[0].click();
			$(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash]);
			$('.zdv-cart-count').updateCartCountFromDOM()
          }
        },
        complete: function () {
          form.unblock();
        }
      });
      return false;
    });
  });
	
	//Cart Count
	(function($) {
		$.fn.updateCartCountFromDOM = function() {
			var $badge = this;
			var $items = $('.widget_shopping_cart_content .mini_cart_item');

			var total = 0;
			$items.each(function() {
				var qtyText = $(this).find('.quantity').text(); // напр. "2 ×"
				var match = qtyText.match(/(\d+)/);
				if (match) {
					total += parseInt(match[1], 10);
				}
			});

			$badge.text(total);
			return this;
		};
	})(jQuery);

	
/*	jQuery(document).ready(function($) {
		var $badge = $('.zdv-cart-count');

		$(document.body).on('wc_fragments_refreshed', function() {
			$badge.updateCartCountFromDOM();
		});

		//$(document.body).trigger('wc_fragment_refresh');
	});*/
	
	//Form CheckOut Validation
	/// Checkout Form
      (function() {
        'use strict';

        window.addEventListener('load', function() {
          // Fetch all the forms we want to apply custom Bootstrap validation styles to
          var forms = document.getElementsByClassName('needs-validation');

          // Loop over them and prevent submission
          var validation = Array.prototype.filter.call(forms, function(form) {
            form.addEventListener('submit', function(event) {
              if (form.checkValidity() === false) {
                event.preventDefault();
                event.stopPropagation();
              }
              form.classList.add('was-validated');
            }, false);
          });
        }, false);
      })();
	//Autoupdate Cart
	jQuery( function( $ ) {
		let timeout;
		$('.woocommerce').on( 'change', 'input.qty', function(){
			if ( timeout !== undefined ) {
				clearTimeout( timeout );
			}
			timeout = setTimeout(function() {
				$("[name='update_cart']").trigger("click"); // trigger cart update
			}, 1000 ); // 1 second delay, half a second (500) seems comfortable too
		});
	} );
	//Menu
	jQuery(function ($) {
	  $('.go-deeper').on('click', function () {
		const targetId = $(this).data('target');
		const $current = $(this).closest('.menu-level');
		const $next = $('#' + targetId);

		// Debug logging (временно, ако искаш)
		// console.log('Opening submenu:', targetId, $next.length);

		$current.addClass('active');
		$next.addClass('show');
	  });

	  $('.go-back').on('click', function () {
		const backLevel = $(this).data('back');
		$(`.menu-level[data-level='${backLevel+1}']`).removeClass('show');
		$(`.menu-level[data-level='${backLevel}']`).removeClass('active');
	  });

	  $('#navbarNavOffcanvas').on('hidden.bs.offcanvas', function () {
		$('.menu-level').removeClass('show active');
	  });
	});
	
	
// Mega Menu: load latest previews with fresh nonces + retry
(function($){
  'use strict';

  // Cache HTML by key; also store in-flight promises to coalesce requests
  const megaMenuCache = {};
  const inFlight = {};

  // Helper: get a fresh nonce (global helper if present, else local)
  function getNonce(key){
    if (window.zdv && typeof zdv.getNonce === 'function') {
      return zdv.getNonce(key);
    }
    // local fallback (minimal)
    window.zdv = window.zdv || {};
    zdv.nonces = zdv.nonces || {};
    if (zdv.nonces[key]) {
      return $.Deferred().resolve(zdv.nonces[key]).promise();
    }
    return $.ajax({
      url: zdv.ajaxurl,
      type: 'POST',
      dataType: 'json',
      data: { action: 'zdv_get_nonce', key: key }
    }).then(function(resp){
      if (resp && resp.success && resp.data && resp.data.nonce) {
        zdv.nonces[key] = resp.data.nonce;
        return resp.data.nonce;
      }
      return $.Deferred().reject(resp).promise();
    });
  }

  function keyFrom(pt, tax, id, promo){
    return [pt || '', tax || '', id || 0, promo ? 1 : 0].join('|');
  }

  function requestPreview(opts){
    const { postType, taxonomy, catId, isPromo } = opts;
    const cacheKey = keyFrom(postType, taxonomy, catId, isPromo);

    // Return cached HTML immediately
    if (megaMenuCache[cacheKey]) {
      return $.Deferred().resolve({ success:true, data:{ html: megaMenuCache[cacheKey] } }).promise();
    }
    // Coalesce concurrent requests for same key
    if (inFlight[cacheKey]) return inFlight[cacheKey];

    function doAjax(){
      return $.when( getNonce('latest_post') ).then(function(nonce){
        return $.ajax({
          url: zdv.ajaxurl,
          type: 'POST',
          dataType: 'json',
          data: {
            action: 'load_latest_post_preview',
            nonce: nonce,
            cat_id: catId,
            taxonomy: taxonomy,
            post_type: postType,
            is_promo: isPromo ? 1 : 0
          }
        });
      });
    }

    const dfd = $.Deferred();
    inFlight[cacheKey] = dfd.promise();

    // initial request
    doAjax().done(function(res){
      // res is WP JSON: { success: true/false, data:{ html: '...' } }
      const html = res && res.data && res.data.html ? String(res.data.html) : '';
      megaMenuCache[cacheKey] = html;
      delete inFlight[cacheKey];
      dfd.resolve(res);
    }).fail(function(jqXHR){
      if (jqXHR && jqXHR.status === 403) {
        // Nonce likely expired between fetch and POST; force refresh and retry once
        if (window.zdv && zdv.nonces) delete zdv.nonces.latest_post;
        doAjax().done(function(res2){
          const html2 = res2 && res2.data && res2.data.html ? String(res2.data.html) : '';
          megaMenuCache[cacheKey] = html2;
          delete inFlight[cacheKey];
          dfd.resolve(res2);
        }).fail(function(){
          delete inFlight[cacheKey];
          dfd.reject(jqXHR);
        });
      } else {
        delete inFlight[cacheKey];
        dfd.reject(jqXHR);
      }
    });

    return dfd.promise();
  }

  function render($preview, res){
    if (res && res.success && res.data && res.data.html && res.data.html.trim().length) {
      $preview.html(res.data.html);
    } else {
      $preview.html('<p class="text-muted">No posts found.</p>');
    }
  }

  // ========== Hover previews ==========
  $('.mega-submenu-item').hoverIntent({
    interval: 100,
    timeout: 200,
    sensitivity: 7,
    over: function () {
      const $item     = $(this);
      const catId     = $item.data('category-id') || '';
      const taxonomy  = $item.data('taxonomy') || '';
      const postType  = $item.data('post-type') || '';
      const isPromo   = $item.hasClass('menu-item-promo') ? 1 : 0; // ensure defined
      const $preview  = $item.closest('.dropdown-menu').find('.mega-post-preview');

      const cacheKey = keyFrom(postType, taxonomy, catId, isPromo);
      if (megaMenuCache[cacheKey]) {
        $preview.html(megaMenuCache[cacheKey]);
        return;
      }

      $preview.html('<p class="text-muted mega-menu-loader"><i class="fa fa-spinner fa-spin ms-2"></i></p>');

      requestPreview({ postType, taxonomy, catId, isPromo })
        .done(function(res){ render($preview, res); })
        .fail(function(){ $preview.html('<p class="text-danger">Error loading preview.</p>'); });
    },
    out: function(){ /* noop */ }
  });

  // ========== Auto-load on first open ==========
  $('.dropdown.position-static').on('mouseenter', function () {
    const $menu      = $(this);
    const $firstItem = $menu.find('.mega-submenu-item.auto-load').first();
    const $preview   = $menu.find('.mega-post-preview');

    if (!$firstItem.length || $preview.hasClass('loaded')) return;

    const catId    = $firstItem.data('category-id') || '';
    const taxonomy = $firstItem.data('taxonomy') || '';
    const postType = $firstItem.data('post-type') || '';
    const isPromo  = $firstItem.hasClass('menu-item-promo') ? 1 : 0;

    const cacheKey = keyFrom(postType, taxonomy, catId, isPromo);
    if (megaMenuCache[cacheKey]) {
      $preview.html(megaMenuCache[cacheKey]).addClass('loaded');
      return;
    }

    $preview.html('<p class="text-muted mega-menu-loader"><i class="fa fa-spinner fa-spin ms-2"></i></p>');

    requestPreview({ postType, taxonomy, catId, isPromo })
      .done(function(res){
        render($preview, res);
        $preview.addClass('loaded');
      })
      .fail(function(){ $preview.html('<p class="text-danger">Error loading preview.</p>'); });
  });

})(jQuery);

	//
/*	$('.zdv-main-navbar .nav-item.dropdown').hoverIntent({
		interval: 100,
		timeout: 200,
		sensitivity: 7,
		over: function () {
			$(this).addClass('show');
			$(this).find('> .dropdown-menu').addClass('show').css({
				display: 'block',
				visibility: 'visible',
				opacity: 1
			});
		},
		out: function () {
			$(this).removeClass('show');
			$(this).find('> .dropdown-menu').removeClass('show').css({
				display: '',
				visibility: '',
				opacity: ''
			});
		}
	});*/
	//Product Page Accordion
	$('#ProductPageAccordion').on('shown.bs.collapse', function (e) {
	  requestAnimationFrame(() => {
		const header = $(e.target).prev('.accordion-header');
		const offset = (document.querySelector('.navbar')?.getBoundingClientRect().height || 0) + 8;
		const rect   = header[0].getBoundingClientRect();
		if (rect.top < offset || rect.bottom > window.innerHeight) {
		  const top = header.offset().top - offset;
		  $('html, body').animate({ scrollTop: Math.max(0, top) }, 250);
		}
	  });
	});
/*	$('#ProductPageAccordion').on('shown.bs.collapse', function (e) {
	  const $header = $(e.target).prev('.accordion-header');
	  const offset = ($('.navbar').outerHeight() || 0) + 8;
	  const rect = $header[0].getBoundingClientRect();
	  if (rect.top < offset || rect.bottom > window.innerHeight) {
		$('html, body').animate({ scrollTop: $header.offset().top - offset }, 250);
	  }
	});*/

	//Prevent Dropdown from closing
	document.addEventListener('DOMContentLoaded', function () {
		document.querySelectorAll('#productMegaAccordion .accordion-button').forEach(function (btn) {
			btn.addEventListener('click', function (e) {
				e.stopPropagation(); // Stop click bubbling to dropdown
			});
		});
	});
	//Acount Dropdown Ajax Load
	$('#zdvAccountDd').on('show.bs.dropdown', function () {
		$.ajax({
			type: 'POST',
            url: zdv.ajaxurl,
			data: { 
				'action': 'zdv_account_menu_content',
			},
			context: this,
			dataType: "html",
			cache: false,
			success: function(data){
				$(".zdv-navbar-account .dropdown-menu").html(data);
			}
		});
	});
	

// ==============================
// Zdravital: Modal Login (JIT nonce + robust errors)
// ==============================
jQuery(function ($) {
  'use strict';

  const $form = $('#zdv_login_form');
  if (!$form.length) return;

  function setBusy(on) {
    const $btn = $form.find('.zdv-login-bt');
    $btn.toggleClass('loading', !!on).prop('disabled', !!on);
    $form.find('.zdv-login-spinner').toggleClass('hidden', !on);
  }
  function showMsg(html) {
    $form.find('.zdv-login .zdv-errors, .zdv-login-errors').html(html);
  }

  // helper: get fresh nonce via your reusable zdv.getNonce()
  function getLoginNonce() {
    if (window.zdv && typeof zdv.getNonce === 'function') return zdv.getNonce('login');
    // minimal fallback (shouldn’t happen if you set zdv.getNonce globally)
    return $.Deferred().resolve(null).promise();
  }

  $form.on('submit', function (e) {
    e.preventDefault();
    if (this.checkValidity && this.checkValidity() === false) {
      this.classList.add('was-validated');
      return;
    }

    setBusy(true);
    showMsg('');

    let retried = false;

    function doPost() {
      return $.when(getLoginNonce()).then(function (nonce) {
        // Build payload manually so we can inject the JIT nonce
        const payload = {
          action: 'zdv_login_member',
          zdv_user_login: $form.find('[name="zdv_user_login"]').val(),
          zdv_user_pass:  $form.find('[name="zdv_user_pass"]').val(),
          rememberme:     $form.find('[name="rememberme"]').is(':checked') ? 1 : 0,
          _ajax_nonce:    nonce // JIT nonce (server will check this first)
        };
        return $.ajax({
          url: (window.zdv && zdv.ajaxurl) ? zdv.ajaxurl : '/wp-admin/admin-ajax.php',
          type: 'POST',
          dataType: 'json',
          cache: false,
          data: payload
        });
      });
    }

    doPost().done(function (res) {
      showMsg(res && res.message ? res.message : '');
      if (res && res.error === false) {
        $form.find('.zdv-login-bt').hide();
        window.location.reload(true);
      } else {
        setBusy(false);
      }
    }).fail(function (jqXHR) {
      // Retry once on 403 (expired/invalid nonce)
      if (jqXHR && jqXHR.status === 403 && !retried) {
        retried = true;
        // clear any cached nonce and retry
        if (window.zdv && zdv.nonces) delete zdv.nonces.login;
        doPost().done(function (res2) {
          showMsg(res2 && res2.message ? res2.message : '');
          if (res2 && res2.error === false) {
            $form.find('.zdv-login-bt').hide();
            window.location.reload(true);
          } else {
            setBusy(false);
          }
        }).fail(function (jqXHR2) {
          const rj = jqXHR2 && jqXHR2.responseJSON;
          showMsg(rj && rj.message ? rj.message :
            '<div class="zdv-error alert alert-danger p-2">Network error. Please try again.</div>');
          setBusy(false);
        });
        return;
      }
      const rj = jqXHR && jqXHR.responseJSON;
      showMsg(rj && rj.message ? rj.message :
        '<div class="zdv-error alert alert-danger p-2">Network error. Please try again.</div>');
      setBusy(false);
    }).always(() => { $form.addClass('was-validated'); });
  });
});

	//Forgot Form Show/Hide
	//Forgot Password
	$("body").on("click", ".login-forget", function(e){
		e.preventDefault();
		$(this).text($(this).attr('data-login_back_text'));
		if($('.zdv-login-dialog').is(':visible')){
			$(this).text($(this).attr('data-login_back_text'));
		}
		else{
			$(this).text($(this).attr('data-login_forgot_text'));
		}
		$($(this).attr('data-login_form_id')).slideToggle();
		$($(this).attr('data-forget_form_id')).slideToggle();
	});
// ==============================
// Zdravital: Forgot Password (JIT nonce + robust errors)
// ==============================
jQuery(function ($) {
  'use strict';

  const $form = $('.zdv-forgot_password-form');
  if (!$form.length) return;

  function setBusy(on) {
    const $btn = $form.find('.zdv-forgot-pass-btn');
    $btn.prop('disabled', !!on).toggleClass('loading', !!on);
    $form.find('.zdv-login-spinner').toggleClass('hidden', !on);
  }
  function showMsg(html) {
    $form.find('.zdv-forgot-psw-messages').html(html);
  }

  function getForgotNonce() {
    if (window.zdv && typeof zdv.getNonce === 'function') return zdv.getNonce('forgot');
    return $.Deferred().resolve(null).promise(); // fallback (shouldn’t happen)
  }

  $form.on('submit', function (e) {
    e.preventDefault();
    if (this.checkValidity && this.checkValidity() === false) {
      this.classList.add('was-validated');
      return;
    }

    setBusy(true);
    showMsg('');
    let retried = false;

    function doPost() {
      return $.when(getForgotNonce()).then(function (nonce) {
        const payload = {
          action: 'zdv_forgot_password',
          user_login_forgot: $form.find('.zdv-login-forgot-id').val(),
          _ajax_nonce: nonce
        };
        return $.ajax({
          url: (window.zdv && zdv.ajaxurl) ? zdv.ajaxurl : '/wp-admin/admin-ajax.php',
          type: 'POST',
          dataType: 'json',
          cache: false,
          data: payload
        });
      });
    }

    doPost().done(function (res) {
      // Always show the server message; it’s user-enum safe
      showMsg(res && res.message ? res.message : '');
      setBusy(false);
    }).fail(function (jqXHR) {
      // Retry once on 403 (expired/invalid nonce)
      if (jqXHR && jqXHR.status === 403 && !retried) {
        retried = true;
        if (window.zdv && zdv.nonces) delete zdv.nonces.forgot;
        doPost().done(function (res2) {
          showMsg(res2 && res2.message ? res2.message : '');
          setBusy(false);
        }).fail(function (jqXHR2) {
          const rj = jqXHR2 && jqXHR2.responseJSON;
          showMsg(rj && rj.message ? rj.message :
            '<div class="zdv-error alert alert-danger p-2">Network error. Please try again.</div>');
          setBusy(false);
        });
        return;
      }
      const rj = jqXHR && jqXHR.responseJSON;
      showMsg(rj && rj.message ? rj.message :
        '<div class="zdv-error alert alert-danger p-2">Network error. Please try again.</div>');
      setBusy(false);
    }).always(() => { $form.addClass('was-validated'); });
  });
});

// ==============================
// Zdravital: Registration JS (nonce-safe, resilient + PoW dev-fallback)
// ==============================
(function ($) {
  'use strict';

  // ---- i18n with safe defaults ----
  const L = (function () {
    const defaults = {
      please_check: 'Please check the highlighted fields.',
      email_mismatch: 'Email address did not match.',
      password_mismatch: 'Password did not match.',
      password_length: 'Password must be at least 8 characters.',
      registration_done: 'Registration complete.',
      something_wrong: 'Something went wrong. Please try again.',
      network_error: 'Network error. Please try again.'
    };
    const i18n = (window.zdv && zdv.i18n) ? zdv.i18n : {};
    return Object.assign({}, defaults, i18n);
  })();

  // ---- PoW helpers (with dev fallback when not secure) ----
  function hasWebCrypto() {
    return window.isSecureContext && window.crypto && window.crypto.subtle && window.TextEncoder;
  }
  async function sha256hex(str){
    if (!hasWebCrypto()) throw new Error('WebCrypto unavailable');
    const enc = new TextEncoder().encode(str);
    const buf = await crypto.subtle.digest('SHA-256', enc);
    return Array.from(new Uint8Array(buf)).map(b=>b.toString(16).padStart(2,'0')).join('');
  }
  // Find x so that sha256(target:ts:x) starts with N zeros
  async function computePoW(prefixZeros){
    // In non-secure dev (http, non-localhost), bypass so you can test locally
    if (!hasWebCrypto()) return 'DEV_BYPASS';
    const target = $('#zdv_pow_target').val() || '';
    const ts = $('#zdv_ts').val() || '';
    const prefix = '0'.repeat(prefixZeros);
    let x = 0, limit = 200000; // cap work to avoid long loops on very slow devices
    while (x < limit) {
      const h = await sha256hex(target + ':' + ts + ':' + x);
      if (h.startsWith(prefix)) return String(x);
      x++;
    }
    return ''; // server will reject on empty
  }

  // ---- UI helpers ----
  function alertMsg(type, text) { return '<div class="alert alert-' + type + ' p-2">' + text + '</div>'; }
  function showMsg($form, html) { $form.find('.zdv-messages').html(html); }
  function setBusy($form, busy) {
    $form.find('.zdv-register-btn').prop('disabled', !!busy);
    const $sp = $form.find('.zdv-register-spinner');
    if (busy) { $sp.removeClass('d-none hidden'); } else { $sp.addClass('d-none hidden'); }
  }
  function clientValidate($form) {
    if ($form[0].checkValidity() === false) {

      $form.addClass('was-validated');
      return { ok: false, msg: alertMsg('danger', L.please_check) };
    }
    const email  = $form.find('#zdv_register_user_email').val().trim();
    const email2 = $form.find('#zdv_register_user_email2').val().trim();
    const pass   = $form.find('#zdv_register_user_password').val();
    const pass2  = $form.find('#zdv_register_user_password2').val();
    const terms  = $form.find('#termsCheck')[0]?.checked;

    if (email !== email2)  return { ok:false, msg: alertMsg('danger', L.email_mismatch) };
    if (pass !== pass2)    return { ok:false, msg: alertMsg('danger', L.password_mismatch) };
    if (pass.length < 8)   return { ok:false, msg: alertMsg('danger', L.password_length) };
    if (!terms)            return { ok:false, msg: alertMsg('danger', L.please_check) };
    return { ok: true };
  }

  // ---- Ensure anti-spam fields are initialized (ts/jsok/target) ----
  function ensureAntiSpamSeeds() {
    const ts = document.getElementById('zdv_ts');
    if (ts && (!ts.value || !/^\d+$/.test(ts.value))) ts.value = String(Math.floor(Date.now()/1000));
    const jsok = document.getElementById('zdv_jsok');
    if (jsok && !jsok.value) jsok.value = Math.random().toString(36).slice(2);
    const tgt = document.getElementById('zdv_pow_target');
    if (tgt && !tgt.value) {
      if (window.crypto && crypto.getRandomValues) {
        const r = crypto.getRandomValues(new Uint32Array(4));
        tgt.value = Array.from(r).map(n => ('00000000'+n.toString(16)).slice(-8)).join('').slice(0,16);
      } else {
        // fallback entropy
        tgt.value = (Date.now().toString(16) + Math.random().toString(16).slice(2)).slice(0,16);
      }
    }
  }

  // Prefetch nonce on first interaction (faster UX) + seed anti-spam fields
  $(document).on('focusin input', '#zdv_register_form', function () {
    const $form = $(this);
    ensureAntiSpamSeeds();
    if ($form.data('nonce-prefetched')) return;
    $form.data('nonce-prefetched', true);
    if (window.zdv && typeof zdv.getNonce === 'function') {
      zdv.getNonce('ajax_register'); // fire & forget
    }
  });

  // ---- Submit with PoW + 403 retry ----
  $(document).on('submit', '#zdv_register_form', function (event) {
    event.preventDefault();
    const $form = $(this);
    if ($form.data('submitting')) return;

    const check = clientValidate($form);
    if (!check.ok) { showMsg($form, check.msg); return; }

    $form.data('submitting', true);
    setBusy($form, true);
    showMsg($form, '');

    function doSubmit() {
      // 1) get fresh nonce; 2) compute PoW; 3) send
      return $.when( zdv.getNonce('ajax_register') ).then(function(nonce){
        // Seed anti-spam values if somehow not set
        ensureAntiSpamSeeds();
        return (async function(){
          const powSolution = await computePoW(3); // raise to 4 if you need more friction
          $('#zdv_pow_solution').val(powSolution); // optional, for visibility in DOM

          const payload = {
            action: 'zdv_register_member',
            register_security: nonce, // PHP expects $_POST['register_security']
            email:     $form.find('#zdv_register_user_email').val().trim(),
            email2:    $form.find('#zdv_register_user_email2').val().trim(),
            phone:     $form.find('#zdv_register_user_phone').val().trim(),
            fname:     $form.find('#zdv_register_user_fname').val().trim(),
            lname:     $form.find('#zdv_register_user_lname').val().trim(),
            password:  $form.find('#zdv_register_user_password').val(),
            password2: $form.find('#zdv_register_user_password2').val(),
            termsCheck: $form.find('#termsCheck')[0]?.checked ? 'agree' : '',
            // Honeypot (must stay empty)
            zdv_hp_company: $form.find('#zdv_hp_company').val() || '',
            // Anti-spam extras
            zdv_ts:  $('#zdv_ts').val() || '',
            zdv_jsok: $('#zdv_jsok').val() || '',
            zdv_pow_target: $('#zdv_pow_target').val() || '',
            zdv_pow_solution: powSolution
          };

          return $.ajax({
            url: zdv.ajaxurl,
            type: 'POST',
            dataType: 'json',
            cache: false,
            data: payload
          });
        })();
      });
    }

    doSubmit().done(function (obj) {
      if (typeof obj === 'string') { try { obj = JSON.parse(obj); } catch (_) {} }
      if (obj && obj.error === false) {
        $form.find('.zdv-reg-form-fields').slideUp();
        $form.closest('.modal-body').find('.zdv-register-modal-login-form').show();
        showMsg($form, obj.message || alertMsg('success', L.registration_done));
        $form.find('.zdv-register-btn').prop('disabled', true);
      } else {
        showMsg($form, (obj && obj.message) ? obj.message : alertMsg('danger', L.something_wrong));
      }
    }).fail(function (jqXHR) {
      // Retry once on 403 (expired nonce)
      if (jqXHR && jqXHR.status === 403 && !$form.data('retried')) {
        $form.data('retried', true);
        if (window.zdv && zdv.nonces) delete zdv.nonces.ajax_register;
        doSubmit().done(function (obj2) {
          if (typeof obj2 === 'string') { try { obj2 = JSON.parse(obj2); } catch (_) {} }
          if (obj2 && obj2.error === false) {
            $form.find('.zdv-reg-form-fields').slideUp();
            $form.closest('.modal-body').find('.zdv-register-modal-login-form').show();
            showMsg($form, obj2.message || alertMsg('success', L.registration_done));
            $form.find('.zdv-register-btn').prop('disabled', true);
          } else {
            showMsg($form, (obj2 && obj2.message) ? obj2.message : alertMsg('danger', L.something_wrong));
          }
        }).fail(function (jqXHR2) {
          const rj = jqXHR2 && jqXHR2.responseJSON;
          const msg = rj && rj.message ? rj.message : alertMsg('danger', L.network_error);
          showMsg($form, msg);
        }).always(function(){
          $form.data('submitting', false);
          setBusy($form, false);
          $form.addClass('was-validated');
        });
        return; // prevent outer always from running twice
      }
      // Non-403: display server message if available
      const rj = jqXHR && jqXHR.responseJSON;
      const msg = rj && rj.message ? rj.message : alertMsg('danger', L.network_error);
      showMsg($form, msg);
    }).always(function () {
      $form.data('submitting', false);
      setBusy($form, false);
      $form.addClass('was-validated');
    });

  });

})(jQuery);





	//Swith The forms
	//Register form login modal
	$("body").on("click", ".zdv-register-modal-login-form", function(e){
		$('.modal-register').modal('hide');
		$('.zdv-user-login-modal').modal('show');
	});
	//Product Zoom
/*	$("body").on("click", ".image-zoom", function(e){
		e.preventDefault();
		$(".zdv-zoom-action").trigger("click");
	});*/
	//Product Image Zoom
	// Product Image Zoom
	(function(){
	  var orig = EventTarget.prototype.addEventListener;
	  EventTarget.prototype.addEventListener = function(type, listener, options){
		// Normalize options
		var opts = (typeof options === 'boolean') ? { capture: options } : (options || {});
		// Force non-passive for touch events on elements in/under .span-wrapper
		var isTouch = (type === 'touchstart' || type === 'touchmove');
		var isElem  = (this instanceof Element);
		if (isTouch && isElem && (this.matches('.span-wrapper, .span-wrapper *'))) {
		  opts.passive = false;
		  return orig.call(this, type, listener, opts);
		}
		return orig.call(this, type, listener, options);
	  };
	})();
	//Product Image Zoom
		$("body").on("click", ".zdv-product-zoom:not(.active)", function (e) {
			e.preventDefault();
			$(this).toggleClass('active');
			$(this)
				.wrap('<span class="span-wrapper" style="display:inline-block"></span>')
				.css('display', 'block')
				.parent()
				.zoom({
					url: $(this).attr('src'),
					on: 'mouseover',
					magnify: 1,
					callback: function () {
						var image = $(this);
						var f_imageWidth = $(this).parent().width();
						var f_imageHeight = $(this).parent().height();
						image.css({
							left: -(image.width() - f_imageWidth)/2,
							top: -(image.height() - f_imageHeight)/2
						}).trigger('mouseover');
					}
				});
		});
		//Destroy on click
		$("body").on("click", ".zdv-product-zoom.active", function (e) {
			e.preventDefault();
			$(this).unwrap();
			$('.zdv-product-zoom').trigger('zoom.destroy'); // remove zoom
			$(this).removeClass('active');
			$('.zoomImg').css('touch-action', 'auto');
		});
		//Destroy on slide change
		$('.single-product .zdv-product-carousel').on('slide.bs.carousel', function () {
		  $('.zdv-product-zoom').trigger('zoom.destroy'); // remove zoom
		  $('.zdv-product-zoom.active').unwrap();
		  $('.zdv-product-zoom.active').removeClass('active');
		});
		//Activating Custom Tooltips
        $(function () {
          $('[data-bs-toggle="popover"]').popover()
        })
	//Sending the Review Form
	//////
	$('#sendReviewForm').submit(function (e) {
		e.preventDefault();
		if ($('#sendReviewForm')[0].checkValidity() === false) {	
			e.stopPropagation();
		}
		else{
			$(this).find('.zdv-loader').toggleClass('hidden');
			$('.zdv-send-comment-button').attr("disabled", true);
            var files = $('#images-review').prop("files");
            //Making the form object
            var form = new FormData();
			$.each(files, function(i, file) {
				form.append(i, file);
			});
			
		    form.append('action', 'zdv_send_review');
			
			var post_id = $("#CommentPostID").val();
			var comment_user_id = $("#CommentUserID").val();
			var name = $("#zdvCommentName").val();
			var email = $("#zdvCommentEmail").val();
			var custom_comment = $("#zdvCommentText").val();
			var commentNonce = $("#comment_nonce").val();
			var commentRating = $(".stars input[type='radio']:checked").val();
			var commentUserID = $("#CommentUserID").val();
			
			form.append('post_id', post_id);
			form.append('comment_user_id', comment_user_id);
			form.append('commenter_name', name);
			form.append('commenter_email', email);
			form.append('comment_text', custom_comment);
			form.append('comment_rating', commentRating);
			form.append('comment_nonce', commentNonce);

			$.ajax({ 
				 data: form,
				 contentType: false,
				 type: 'post',
				 dataType: 'json',
				 processData : false,
				 cache: false,
				 url: zdv.ajaxurl,
				 success: function(data) {
				 $(".zdv-send-comment-button .zdv-loader").removeClass("hidden");	 
					 if(data.error === false) {

						$('.zdv-comment-form-wrapper').hide();
						$('#ReviewFormModal .modal-body').html(data.message);

					 }
					 if(data.error === true) {

						$('.zdv-comment-form-wrapper').hide();
						$('#ReviewFormModal .modal-body').html(data.message);

					 }
				 }
			});
		}
		$('#sendReviewForm').addClass('was-validated');
	});
	//File Uploader
	  $('.zdv-review-images').imageUploader({
		label: 'Избор на снимки',
		extensions: ['.jpg', '.jpeg'],
		mimes: ['image/jpeg'],
		maxFiles: 6
	  });
	//Sending the Comment Form
	//////
	$('#sendCommentForm').submit(function (e) {
		e.preventDefault();
		if ($('#sendCommentForm')[0].checkValidity() === false) {	
			e.stopPropagation();
		}
		else{
			$(this).find('.zdv-loader').toggleClass('hidden');
			$('.zdv-send-comment-button').attr("disabled", true);
			var form = new FormData();
		    form.append('action', 'zdv_send_comment');
			
			var post_id = $("#CommentPostID").val();
			var comment_user_id = $("#CommentUserID").val();
			var name = $("#zdvCommentName").val();
			var email = $("#zdvCommentEmail").val();
			var custom_comment = $("#zdvCommentText").val();
			var commentNonce = $("#comment_nonce").val();
			var commentUserID = $("#CommentUserID").val();
			
			form.append('post_id', post_id);
			form.append('comment_user_id', comment_user_id);
			form.append('commenter_name', name);
			form.append('commenter_email', email);
			form.append('comment_text', custom_comment);
			form.append('comment_nonce', commentNonce);

			$.ajax({
				 data: form,
				 contentType: false,
				 type: 'post',
				 dataType: 'json',
				 processData : false,
				 cache: false,
				 url: zdv.ajaxurl,
				 success: function(data) {
				 $(".zdv-send-comment-button .zdv-loader").removeClass("hidden"); 
					 if(data.error === false) {
						$('.zdv-comment-form-wrapper').hide();
						$('.zdv-comment-message').html(data.message);
					 }
					 if(data.error === true) {
						$('.zdv-comment-form-wrapper').hide();
						$('.zdv-comment-message').html(data.message);
					 }
				 }
			});
		}
		$('#sendCommentForm').addClass('was-validated');
	});
// ==============================
// Contact Form (nonce + PoW; no CAPTCHA)
// ==============================
jQuery(function($){
  'use strict';

  const $form = $('#sendContactForm');
  if (!$form.length) return;

  function setBusy(on){
    $('.zdv-loader').toggleClass('hidden', !on);
    $('.zdv-send-email-action').prop('disabled', !!on).toggleClass('disabled', !!on);
  }

  // Prefill JS challenge & timestamp if missing
  (function(){
    var jsok = document.getElementById('zdv_jsok');
    if (jsok && !jsok.value) jsok.value = Math.random().toString(36).slice(2);
    var ts = document.getElementById('zdv_ts');
    if (ts && (!ts.value || !/^\d+$/.test(ts.value))) ts.value = String(Math.floor(Date.now()/1000));
    // Prepare a PoW target (16 hex chars random) — server will verify prefix
    var tgt = document.getElementById('zdv_pow_target');
    if (tgt && !tgt.value) tgt.value = (crypto.getRandomValues(new Uint32Array(4)))
      .reduce((s,n)=>s+('00000000'+n.toString(16)).slice(-8),'').slice(0,16);
  })();

// WebCrypto SHA-256 (use only in secure contexts); dev fallback otherwise
function hasWebCrypto() {
  return window.isSecureContext && window.crypto && window.crypto.subtle && window.TextEncoder;
}

async function sha256hex(str){
  if (!hasWebCrypto()) throw new Error('WebCrypto unavailable');
  const enc = new TextEncoder().encode(str);
  const buf = await crypto.subtle.digest('SHA-256', enc);
  const arr = Array.from(new Uint8Array(buf));
  return arr.map(b => b.toString(16).padStart(2,'0')).join('');
}

// Do small PoW; if not secure, return a sentinel for server-side dev bypass
async function computePoW(prefixZeros){
  if (!hasWebCrypto()) {
    return 'DEV_BYPASS'; // tell the server to bypass in dev
  }
  const target = $('#zdv_pow_target').val() || '';
  const ts = $('#zdv_ts').val() || '';
  const prefix = '0'.repeat(prefixZeros);
  let x = 0, limit = 200000;
  while (x < limit) {
    const cand = target + ':' + ts + ':' + x;
    const h = await sha256hex(cand);
    if (h.startsWith(prefix)) return String(x);
    x++;
  }
  return '';
}

  // Helper: get fresh nonce (uses global zdv.getNonce if available)
  function getNonce(key){
    if (window.zdv && typeof window.zdv.getNonce === 'function') {
      return window.zdv.getNonce(key);
    }
    // minimal local fallback
    window.zdv = window.zdv || {}; const Z = window.zdv; Z.nonces = Z.nonces || {};
    if (Z.nonces[key]) return $.Deferred().resolve(Z.nonces[key]).promise();
    return $.ajax({
      url: Z.ajaxurl || '/wp-admin/admin-ajax.php',
      type: 'POST', dataType: 'json',
      data: { action:'zdv_get_nonce', key }
    }).then(function(resp){
      if (resp && resp.success && resp.data && resp.data.nonce) {
        Z.nonces[key] = resp.data.nonce; return resp.data.nonce;
      }
      return $.Deferred().reject(resp).promise();
    });
  }

  $form.on('submit', function (e) {
    e.preventDefault();
    const formEl = this;

    if (formEl.checkValidity() === false) {
      e.stopPropagation();
      $form.addClass('was-validated');
      return;
    }

    let triedRetry = false;
    setBusy(true);
    $('#zdvSendEmailMessage').html('');

    async function buildPayload(){
      // compute PoW (tune difficulty here; start with 3 zeros)
      const solution = await computePoW(3);
      $('#zdv_pow_solution').val(solution);

      const nonce = await $.when( getNonce('send_email') );
      // put fresh nonce into hidden field
      var $nonceField = $('#send_email_nonce');
      if ($nonceField.length) { $nonceField.val(nonce); }

      return {
        action: 'zdv_send_email_subsite',
        contactName:     $("#zdvContactName").val(),
        contactEmail:    $("#zdvContactEmail").val(),
        contactSubject:  $("#zdvContactSubject").val(),
        emailMessage:    $("#zdvMessage").val(),
        contactFormNonce: $nonceField.length ? $nonceField.val() : nonce,
        // anti-spam extras
        company: $("input[name='company']").val() || '',
        zdv_ts: $("#zdv_ts").val(),
        zdv_jsok: $("#zdv_jsok").val(),
        zdv_pow_target: $("#zdv_pow_target").val(),
        zdv_pow_solution: $("#zdv_pow_solution").val()
      };
    }

    (async function send(){
      try {
        const payload = await buildPayload();
        $.ajax({
          url: (window.zdv && zdv.ajaxurl) ? zdv.ajaxurl : '/wp-admin/admin-ajax.php',
          type: 'POST', dataType: 'json', cache: false,
          data: payload, context: formEl
        }).done(function(data){
          $('#zdvSendEmailMessage').html(data && data.message ? data.message : '');
          if (data && data.error === false) {
            $(formEl).hide(300);
          } else {
            setBusy(false);
          }
        }).fail(function(jqXHR){
          // Retry once on 403 (expired nonce)
          if (jqXHR && jqXHR.status === 403 && !triedRetry) {
            triedRetry = true;
            if (window.zdv && zdv.nonces) delete zdv.nonces.send_email;
            send(); // rebuild with fresh nonce + new PoW
          } else {
            setBusy(false);
            $('#zdvSendEmailMessage').html('<p class="alert alert-danger p-2 rounded">Network error. Please try again.</p>');
          }
        }).always(function(){
          $form.addClass('was-validated');
        });
      } catch(e){
        setBusy(false);
        $('#zdvSendEmailMessage').html('<p class="alert alert-danger p-2 rounded">Unexpected error. Please try again.</p>');
      }
    })();
  });
});



		//
		$('.zdv-home-sliders').on('init', function(event, slick){
	  		$('.home-tabs-loader').hide();
		});
	//Sliders
	$(function () {
	  $('.zdv-home-sliders').each(function () {
		const $slider = $(this);

		if ($slider.hasClass('slick-initialized')) return; // avoid double init

		// Reveal only after Slick finishes sizing THIS slider
		$slider.on('setPosition.initReady', function () {
		  $slider.addClass('is-ready');
		  $slider.off('setPosition.initReady'); // run once
		});

		// Init (per instance)
		$slider.slick({
				prevArrow: '<span class="zdv-left-slide-arrow zdv-slide-arrow"><i class="fa fa-chevron-circle-left"></i></span>',
				nextArrow: '<span class="zdv-right-slide-arrow zdv-slide-arrow"><i class="fa fa-chevron-circle-right"></i></span>',
				slidesToShow: 4,
				slidesToScroll: 1,
				dots: false,
				centerMode: false,
				infinite: true,
				focusOnSelect: true,
			    adaptiveHeight: true,
			    lazyLoad: 'ondemand',
			    waitForAnimate: false,
				  responsive: [
					{
					  breakpoint: 769,
					  settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						infinite: true,
					  }
					},
					{
					  breakpoint: 577,
					  settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						infinite: true,
						centerMode: false,
					  }
					},
				  ]
		});
	  });
	});
	//Console Fix
	// Passive event listeners
	jQuery.event.special.touchstart = {
		setup: function( _, ns, handle ) {
			this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
		}
	};
	jQuery.event.special.touchmove = {
		setup: function( _, ns, handle ) {
			this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
		}
	};

///////////
});///Don't touch this
///////////